// extracted by mini-css-extract-plugin
export default {"container":"LeadingVisual-module__container--x58cX","hasNewActivity":"LeadingVisual-module__hasNewActivity--_pcEM","visualContainer":"LeadingVisual-module__visualContainer--r2z_9"};